class ConfigurableModalController {
    constructor($scope, $uibModalInstance, options) {
        this.$scope = $scope;
        this.$uibModalInstance = $uibModalInstance;

        $scope.loading = true;

        const dataCallback = (data) => {
            options.data = data
            this.init(options)
            this.$scope.loading = false
        }

        if (typeof options.data === "function") {
            options.data.call(null, dataCallback) 
        } else {
            dataCallback(options.data)
        }
    }

    init(options) {
        const $scope = this.$scope

        const { actions, steps, title } = options.data;
        this.actions = actions;
        this.steps = steps;
        this.onNext = options.onNext;
        this.onComplete = options.onComplete

        $scope.formData = steps.map(step => {
            return step.rows.map(row => {
                const updatedRow = { ...row };
                step.fieldRows.flat().forEach(field => {
                    if (!Object.prototype.hasOwnProperty.call(updatedRow, field.fieldId)) {
                        updatedRow[field.fieldId] = null;
                    }
                });
                return updatedRow;
            });
        });

        $scope.currentStep = 0;
        $scope.currentConfig = steps[0];
        $scope.title = title;

        $scope.actions = actions;

        $scope.nextStep = () => this.nextStep();
        $scope.prevStep = () => this.prevStep();
        $scope.primaryAction = () => this.primaryAction();
        $scope.cancel = () => this.cancel();
        $scope.isLastStep = () => this.isLastStep();

        this.updateNavigationButtons();
    }

    isLastStep() {
        return this.$scope.currentStep === this.steps.length - 1;
    }

    updateNavigationButtons() {
        const $scope = this.$scope;
        const actions = this.actions;

        $scope.cancelButtonLabel = actions?.close?.label || "Close";
        $scope.cancelButtonTitle = actions?.close?.title || "Close";

        $scope.previousButtonLabel = actions?.previous?.label || "Previous";
        $scope.previousButtonTitle = actions?.previous?.title || "Go back to the previous step";

        if (this.isLastStep()) {
            $scope.actionButtonLabel = actions?.dismiss?.label || "Finish";
            $scope.actionButtonTitle = actions?.dismiss?.title || "Complete the process";
        } else {
            $scope.actionButtonLabel = actions?.next?.label || "Next";
            $scope.actionButtonTitle = actions?.next?.title || "Proceed to the next step";
        }
    }

    nextStep() {
        const $scope = this.$scope;

        if (!$scope.stepForm.$valid) {
            this.touchInvalidFields();
            return;
        }
    
        const proceedToNext = () => {
            console.log($scope.currentStep)
            if ($scope.stepForm.$valid) {
                $scope.currentStep++;
                $scope.currentConfig = this.steps[$scope.currentStep];
                console.log($scope.formData, $scope.formData[$scope.currentStep])
                this.updateNavigationButtons();
            } else {
                this.touchInvalidFields();
            }
        };
    
        if (this.onNext) {
            this.onNext.call(
                null,
                $scope.currentStep,
                angular.copy($scope.formData[$scope.currentStep]),
                proceedToNext
            );
        } else {
            proceedToNext();
        }
    }    

    prevStep() {
        const $scope = this.$scope;
        if ($scope.currentStep > 0) {
            $scope.currentStep--;
            $scope.currentConfig = this.steps[$scope.currentStep];
            this.updateNavigationButtons();
        }
    }

    primaryAction() {
        const $scope = this.$scope;

        const finalizeModal = () => {
            if ($scope.stepForm.$valid) {
                this._finalizeModal();
            } else {
                this.touchInvalidFields();
            }
        };

        if (this.isLastStep()) {
            if (this.onComplete) {
                this.onComplete.call(null, $scope.formData[$scope.currentStep], finalizeModal);
            } else {
                finalizeModal();
            }
        } else {
            this.nextStep();
        }
    }

    cancel() {
        this.$uibModalInstance.dismiss("cancel");
    }

    _finalizeModal() {
        this.$uibModalInstance.close(this.$scope.formData);
    }

    touchInvalidFields() {
        angular.forEach(this.$scope.stepForm.$error, errorFields => {
            angular.forEach(errorFields, field => {
                field.$setTouched();
            });
        });
    }
}

ConfigurableModalController.$inject = ["$scope", "$uibModalInstance", "options"];
angular.module("cpm").controller("ConfigurableModalController", ConfigurableModalController);
